import money from '../../helpers/money';

const formatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
};
const methodDisplay = {
  1: 'Abono en Cuenta Corriente del Banco de Chile',
  2: 'Vale Vista entregado en Mesón del Banco de Chile',
  4: 'Vale Vista entregado directamente a la empresa',
  6: 'Abono en Cuenta de Ahorro del Banco de Chile',
  7: 'Abono en Cuenta Corriente de Otros Bancos',
  8: 'Abono en Cuenta de Ahorro de Otros Bancos',
  11: 'Abono en Bancuenta Credichile',
  12: 'Pago en efectivo Servipag',
};
const formatDate = (date) => {
  if (!date) {
    return '';
  }
  return Intl.DateTimeFormat('en-US', formatOptions).format(date.toDate());
};
const formatInternalRow = ({ transaction_id, dest_url, dest_name, desc, currency, amount, dest_uri, status, error, closed_at, created_at, updated_at, value_at }) => {
  const formattedRow = {
    transaction_id,
    dest_url,
    dest_name,
    desc,
    currency,
    amount,
    dest_uri,
    status,
    error,
    closed_at: formatDate(closed_at),
    created_at: formatDate(created_at),
    updated_at: formatDate(updated_at),
    value_at: formatDate(value_at),
  };
  return formattedRow;
};

const extractDataFromUri = (uri) => {
  const url = new URL(uri);
  return Object.fromEntries(url.searchParams.entries());
};

const formatExternalRow = ({ dest_uri, dest_name, currency, amount, status, error }) => {
  const { ident: rut, payment_method } = extractDataFromUri(dest_uri);
  const formattedRow = {
    rut,
    dest_name,
    payment_method: methodDisplay[Number.parseInt(payment_method, 10)],
    amount: money.toDisplay(Number.parseInt(amount, 10), currency, false),
    status,
    error,
  };
  return formattedRow;
};
const internal = (items, transactions) => {
  const exportable = items.map((item) => {
    const transaction = transactions.filter(({ id }) => id === item.transaction_id.substr(8));
    let res = { ...item };
    if (transaction.length) {
      res = { ...transaction[0], ...res };
    }

    return formatInternalRow(res);
  });
  const response = { exportable };
  return response;
};
const external = (items, transactions) => {
  const exportable = items.map((item) => {
    const transaction = transactions.filter(({ id }) => id === item.transaction_id.substr(8));
    let res = item;
    if (transaction.length) {
      res = { ...transaction[0], ...res };
    }

    return formatExternalRow(res);
  });
  const headers = [
    ['RUT', 'Nombre Beneficiario', 'Medio Pago', 'Monto $', 'Estado', 'Errores'],
  ];
  const response = {
    exportable,
    headers,
    options: { header: ['rut', 'dest_name', 'payment_method', 'amount', 'status', 'error'], skipHeader: true, origin: 'A2' },
  };
  return response;
};
const csvExportFunctions = {
  internal,
  external,
};
export { csvExportFunctions };
